<template>
  <div class="guide-count">
    <span style="vertical-align: -10px">争议金额:  </span>
    <el-input v-model="money" type="text" value="" autocomplete="off">
      <el-button slot="append" @click="countFee">计算</el-button>
    </el-input>
    <table class="table table-bordered">
      <tr>
        <th>费用类型</th>
        <th>费用金额（元）</th>
      </tr>
      <tr>
        <td>仲裁费</td>
        <td>{{shouli&&shouli}}</td>
      </tr>
    </table>
    <div class="mt10">以上计算结果针对非批量网上仲裁案件，如与本会计算结果存在差异，以本会的计算为准。</div>
<div style="overflow: hidden;">
  <div style="width: 50%;float: left;">
    <p style="margin-top: 20px;">中国海事仲裁委员会网上仲裁费用表：</p>
    <table border="1" style="border: 1px solid #ccc; border-collapse: collapse;">
      <tr>
        <td>争议金额（人民币）</td>
        <td>仲裁费用（人民币）</td>
      </tr>
      <tr>
        <td>5,000元以下</td>
        <td>500元</td>
      </tr>
      <tr>
        <td>5,001元至10,000元</td>
        <td>1,000元</td>
      </tr>
      <tr>
        <td>10,001元至50,000元</td>
        <td>2,000元</td>
      </tr>
      <tr>
        <td>50,001元至100,000元</td>
        <td>4,000元</td>
      </tr>
      <tr>
        <td>100,001元至150,000元</td>
        <td>6,500元</td>
      </tr>
      <tr>
        <td>150,001元至200,000元</td>
        <td>9,500元</td>
      </tr>
      <tr>
        <td>200,001元至500,000元</td>
        <td>9,500元+超过20万元部分的3%</td>
      </tr>
      <tr>
        <td>500,001元至1,000,000元</td>
        <td>18,500元+超过50万元部分的1.7%</td>
      </tr>
      <tr>
        <td>1,000,001元至2,000,000元</td>
        <td>27,000元+超过100万元部分的0.7%</td>
      </tr>
      <tr>
        <td>2,000,001元至10,000,000元</td>
        <td>34,000元+超过200万元部分的0.6%</td>
      </tr>
      <tr>
        <td>10,000,001元至20,000,000元</td>
        <td>82,000元+超过1000万元部分的0.5%</td>
      </tr>
      <tr>
        <td>20,000,001元以上</td>
        <td>132,000元+超过2000万元部分的0.4%</td>
      </tr>
    </table>
  </div>
</div>



  </div>
</template>

<script>
  import {countFee} from 'api/common'

  export default {
    data() {
      return {
        money: '',
        shouli: '',
        chuli: ''
      }
    },
    methods: {
      countFee() {
        var me = this;
        var grep = /^([1-9]\d*|\d+\.\d{1,2})$/
        if (!grep.test(me.money)) {
          me.$message({
            type: 'warning',
            message: '金额只能是数字，且最多含两位小数！'
          });
          return;
        }
        if (me.money > 999999999) {
          me.$message({
            type: 'warning',
            message: '金额数字应小于10亿！'
          })
          return;
        }
        countFee(this.money).then(function (res) {
          console.log(res)
          me.shouli = res.data.first;
          me.chuli = res.data.second;
        }).catch(function (res) {
          console.log(res)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .guide-count {
    font-size: 14px;
  }

  .el-input {
    width: 360px;
    font-size: 14px;
    vertical-align: center;
  }

  .fee-item {
    font-size: 14px;
    margin-top: 10px;
    padding: 5px;
  }

  .table {
    width: 422px;
    overflow: hidden;
    margin: 20px 0;
    text-align: center;
    td {
      font-size: 14px;
    }

    td:first-of-type {
      width: 33%;
      text-align: center;
      padding-right: 4px;
    }
  }
  table {
    width: 500px;
    td {
      padding: 8px 14px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/home/guide/components/count.vue